import { makeStyles } from '@material-ui/core';

export default makeStyles(({ spacing }) => ({
  subtitle: {
    marginTop: spacing(3),
    marginBottom: spacing(5),
  },
  dividerWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: spacing(5),
    marginBottom: spacing(5),
  },
  icon: {
    display: 'block',
    margin: `${spacing(5)}px auto`,
  },
  error: {
    marginTop: spacing(6.5),
    marginBottom: spacing(5),
  },
  noLocationBanner: {
    marginTop: spacing(8),
    marginBottom: spacing(10.5),
  },
  continueButton: {
    marginBottom: spacing(10),
  },
  irelandRedirect: {
    marginTop: spacing(10),
  },
  linkText: {
    textDecoration: 'underline',
    color: 'inherit',
  },
  privacyPolicy: {
    marginTop: spacing(5),
    marginBottom: spacing(10),
  },
  scanButton: {
    fontSize: '16px',
  },
}));
